import React from 'react';
import { useNavigate } from 'react-router-dom';
import SearchComponent from './SearchComponent';
import Navbar from './Navbar';
import HeroBackground from '../assets/Rectangle 182.webp';
import { useAuth } from '../context/AuthContext';

function Header() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const navProtected = (path) => isAuthenticated ? navigate(path) : navigate('/login');

  return (
    <header className="relative text-white">
      <Navbar />

      {/* Hero con imagen de fondo */}
      <div className="relative min-h-[420px] md:min-h-[580px] lg:min-h-[640px] overflow-hidden">
        <img
          src={HeroBackground}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
        />
        {/* Overlay oscuro */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Contenido del hero: dos columnas */}
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center pt-36 pb-8 md:pt-48 md:pb-10">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 w-full">

            {/* Columna izquierda: título + subtítulo + botones */}
            <div className="flex-1 text-center lg:text-left">
              <p className="text-4xl md:text-6xl xl:text-7xl font-black font-montserrat drop-shadow-2xl leading-none tracking-tight">
                Más destinos, más oportunidades: tu socio en Argentina, Brasil y el mundo.
              </p>
              <p className="text-2xl md:text-3xl text-white/80 mt-4 max-w-lg leading-relaxed mx-auto lg:mx-0">
                Expertos en salidas grupales.
              </p>
              <div className="flex flex-wrap gap-4 mt-8 justify-center lg:justify-start">
                <button
                  onClick={() => navProtected('/paquetes')}
                  className="bg-[#2AA8B0] text-white font-bold px-8 py-4 rounded-full hover:bg-[#1E8A91] hover:scale-105 transition-all shadow-xl text-base"
                >
                  Ver promociones
                </button>
                <button
                  onClick={() => navProtected('/paquetes')}
                  className="bg-white/15 backdrop-blur-sm text-white font-semibold px-8 py-4 rounded-full border border-white/40 hover:bg-white/25 hover:scale-105 transition-all shadow-lg text-base"
                >
                  Explorar categorías
                </button>
              </div>
            </div>

            {/* Columna derecha: buscador (oculto en mobile, visible desde lg) */}
            <div className="w-full lg:w-[380px] xl:w-[420px] flex-shrink-0">
              <div className="shadow-[0_10px_40px_rgba(0,0,0,0.5)] rounded-3xl">
                <SearchComponent vertical={true} />
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
